module.exports = __webpack_public_path__ + "img/index-t-slide1.8de2880f.png";